import request from './AxiosRequest';

const getNotificationSetting = contentId => 
	request({
		url: `/Services/api/contentsubscription?ContentId=${contentId}`,
		method: 'GET'
	});

const setNotificationSetting = data => 
	request({
		url: '/Services/api/contentsubscription',
		method: 'POST',
		data
	});

const ContentSubscriptionService = {
	getNotificationSetting,
	setNotificationSetting
};

export default ContentSubscriptionService;
